import React from 'react';

// Botón heredado, con el estilo nuevo (píldora). Para pantallas nuevas usa components/ui/Btn.
const VARIANTS = {
  primary:   'bg-fg text-ink hover:bg-fg/85',
  secondary: 'bg-raised text-fg ring-1 ring-inset ring-line hover:ring-fg/20',
  outline:   'bg-transparent text-fg-dim ring-1 ring-inset ring-line hover:text-fg hover:bg-raised',
  danger:    'bg-transparent text-signal ring-1 ring-inset ring-signal/40 hover:bg-signal-soft',
  success:   'bg-live-soft text-live ring-1 ring-inset ring-live/30 hover:bg-live/20',
  warning:   'bg-caution-soft text-caution ring-1 ring-inset ring-caution/30 hover:bg-caution/20',
};
const SIZES = { sm: 'h-8 px-3.5 text-[13px]', md: 'h-10 px-5 text-[14px]', lg: 'h-12 px-6 text-[15px]' };

const Button = ({ type = 'button', disabled = false, className = '', onClick, children, variant = 'primary', fullWidth = false, size = 'md', leftIcon, rightIcon, loading = false }) => (
  <button
    type={type}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    onClick={onClick}
    className={`inline-flex justify-center items-center gap-2 whitespace-nowrap rounded-full font-semibold transition duration-150 active:scale-[0.98]
      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-live focus-visible:ring-offset-2 focus-visible:ring-offset-ink
      disabled:opacity-40 disabled:cursor-not-allowed ${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size] || SIZES.md} ${fullWidth ? 'w-full' : ''} ${className}`}
  >
    {loading ? <span className="h-3.5 w-3.5 rounded-full border-2 border-current border-r-transparent animate-spin" aria-hidden /> : (<>
      {leftIcon && <span aria-hidden className="inline-flex">{leftIcon}</span>}
      {children}
      {rightIcon && <span aria-hidden className="inline-flex">{rightIcon}</span>}
    </>)}
  </button>
);

export default Button;
